export const PAGE_W = Math.round((210 / 25.4) * 96); // ≈ 794
export const PAGE_H = Math.round((297 / 25.4) * 96); // ≈ 1123

export async function toBase64FromPublic(pathFromPublic) {
  const url = new URL(pathFromPublic, window.location.origin).href;
  const res = await fetch(url);
  if (!res.ok) throw new Error("Cannot fetch " + url);
  const blob = await res.blob();

  return await new Promise(function (resolve, reject) {
    const reader = new FileReader();
    reader.onloadend = function () {
      resolve(String(reader.result));
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export function absolutifyImgs(root) {
  root.querySelectorAll("img").forEach(function (img) {
    var src = img.getAttribute("src") || img.src;
    if (!src || src.startsWith("data:")) return;
    try {
      img.src = new URL(src, window.location.origin).href;
    } catch (e) {}
  });
}

export async function base64ifyLogos(
  root,
  placeholder = "/images/default-profile.png",
) {
  const logos = root.querySelectorAll("img.profile-logo");
  for (const el of Array.from(logos)) {
    const img = el;
    const src = img.getAttribute("src") || "";
    if (!src || src.startsWith("data:")) continue;
    try {
      const u = new URL(src, window.location.origin);
      if (u.origin === window.location.origin) {
        img.src = await toBase64FromPublic(u.pathname);
      } else {
        img.src = u.href;
      }
    } catch (e) {
      img.src = new URL(placeholder, window.location.origin).href;
    }
  }
}

export function buildPrintHTML(
  innerHtml,
  watermarkMode = "fixed",
  options = {},
) {
  const hasProfileFooter = innerHtml.includes("profile-download-footer");
  const isProfileDocument =
    hasProfileFooter || innerHtml.includes("profile-container");
  const profileFontFamily =
    '"Be Vietnam Pro PDF","Be Vietnam Pro",Arial,Helvetica,sans-serif';
  const profileFontFaceCSS =
    isProfileDocument && options.profileFontRegularBase64
      ? `
    @font-face{
      font-family:"Be Vietnam Pro PDF";
      src:url("${options.profileFontRegularBase64}") format("truetype");
      font-weight:400;
      font-style:normal;
      font-display:block;
    }
    @font-face{
      font-family:"Be Vietnam Pro PDF";
      src:url("${options.profileFontBoldBase64 || options.profileFontRegularBase64}") format("truetype");
      font-weight:700;
      font-style:normal;
      font-display:block;
    }
  `
      : "";

  const watermarkAbsoluteCSS = `
    /* ABSOLUTE: phủ vùng nội dung (KHÔNG LẶP THEO TRANG) */
    #contentToPrint { position: relative; }
    .wm-overlay {
      position: absolute;
      inset: 0;
      background-size: 90%;
      background-repeat: no-repeat;
      background-position: center;
      opacity: 0.12;
      pointer-events: none;
      z-index: 10000;
    }
  `;

  const watermarkFixedCSS = `
    /* FIXED: Chromium/Puppeteer render lại ở MỖI TRANG */
    .wm-overlay-fixed {
      position: fixed;
      inset: 0;
      padding: ${isProfileDocument ? "0.8cm 1.15cm" : "2.5cm 1.5cm"};
      background-image: var(--wm-url);
      background-size: ${isProfileDocument ? "90%" : "95%"};
      background-repeat: no-repeat;
      background-position: center;
      background-origin: content-box;
      opacity: 0.12;
      pointer-events: none;
      z-index: 2147483647;
    }
    @media print {
      .wm-overlay-fixed { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      html, body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    }
  `;

  const overlayHtml =
    watermarkMode === "absolute"
      ? `<div class="wm-overlay" id="wm-layer"></div>`
      : `<div class="wm-overlay-fixed" id="wm-layer"></div>`;

  const profileFooterHTML = `
    <div class="profile-download-footer">
      <p>Hồ sơ được tải về ngày ${new Date().toLocaleDateString("vi-VN")} từ Nền tảng số Sohuutritue.vn</p>
      <p>Tổng đài tư vấn Sở hữu trí tuệ: <a href="tel:0819009697">08 1900 9697</a> (điện thoại, zalo) - Email: <a href="mailto:luatsu@sohuutritue.vn">luatsu@sohuutritue.vn</a></p>
    </div>`;
  const defaultFooterHTML = `
    <div class="generic-download-footer">
      <p>Tài liệu được xuất ngày ${new Date().toLocaleDateString("vi-VN")} từ Nền tảng số Sohuutritue.vn</p>
      <p>Tổng đài tư vấn Sở hữu trí tuệ: <a href="tel:0819009697">08 1900 9697</a> (điện thoại, zalo) - Email: <a href="mailto:luatsu@sohuutritue.vn">luatsu@sohuutritue.vn</a></p>
    </div>`;
  const footerHTML = isProfileDocument
    ? hasProfileFooter
      ? ""
      : profileFooterHTML
    : defaultFooterHTML;
  const profileCompactCSS = isProfileDocument
    ? `
    .profile-container { 
      border: none !important; 
      width: 100% !important;
      display: block !important;
      padding: 0 !important;
      font-family:${profileFontFamily} !important;
    }
    
    .profile-heading {
      width: 100% !important;
      text-align: center !important;
      margin: 0 0 8px 0 !important;
      display: block !important;
      padding: 0 0 6px 0 !important;
    }

    .profile-meta-grid { 
      display: grid !important;
      grid-template-columns: repeat(3, 1fr) !important;
      margin: 0 auto 12px auto !important;
      gap: 8px 10px !important;
      width: 100% !important;
    }
    
    .meta-item {
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      gap: 6px !important;
      width: 100% !important;
      font-size:13px !important;
      line-height:1.45 !important;
    }
    
    .meta-value {
      color: #000;
      font-weight:400 !important;
    }

    .w-full.flex.items-center.justify-center {
      display: flex !important;
      justify-content: center !important;
      width: 100% !important;
      margin: 8px 0 !important;
    }

    .profile-logo {
      height: 5rem !important;
      margin: 0 auto !important;
      display: block !important;
      object-fit: contain;
    }

    .dynamic-content-wrapper {
      width: 100% !important;
      display: block !important;
      margin-bottom: 14px !important;
    }

    .space-y-6 > div {
       margin-bottom: 14px !important;
    }

    .w-full{width:100%} .text-center{text-align:center} .uppercase{text-transform:uppercase}
    .border-b{border-bottom:none !important} .p-4{padding:1rem} .border{border:1px solid #e5e7eb !important} .rounded-lg{border-radius:.5rem !important} .overflow-hidden{overflow:hidden !important}
    .mt-10{margin-top:.4rem !important} .mb-8{margin-bottom:.6rem !important} .mb-6{margin-bottom:.5rem !important} .mt-8{margin-top:.75rem !important} .mt-16{margin-top:1rem !important}
    .flex{display:flex} .flex-col{flex-direction:column} .items-center{align-items:center} .items-start{align-items:flex-start} .justify-center{justify-content:center}
    .gap-3{gap:.45rem} .gap-4{gap:1rem} .mr-2{margin-right:4px} .gap-y-6{row-gap:1.5rem} .mb-4{margin-bottom:.8rem}
    .font-semibold{font-weight:700} .whitespace-nowrap{white-space:nowrap}
    .table-heading{color:#fff;background:#0457C2;padding:12px}
    .rounded-t-lg{border-top-left-radius:.5rem;border-top-right-radius:.5rem}
    .grid{display:grid} .grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}
    @media (min-width:1280px){ .xl\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))} }

    .text-\\[1\\.5rem\\]{font-size:1.5rem}
    .text-\\#0457C2{color:#0457C2}
    .font-sf-semibold{font-weight:700} .font-sf-medium{font-weight:400}
    .text-gray-400{color:#9ca3af !important} .italic{font-style:italic !important}

    h4{font-size:13px !important;line-height:1.45 !important;margin:0 0 6px 0 !important;font-weight:700 !important}
    p,span,strong,div{line-height:1.45}
    strong{font-weight:700}
    .hide-section, #download-btn { display: none !important; }
    .pdf-only-row { display: table-row !important; }
    .profile-extra-info{
      border:none !important;
      background:transparent !important;
      box-shadow:none !important;
      border-radius:0 !important;
      padding:0 !important;
      margin-top:14px !important;
      margin-bottom:14px !important;
    }
    .profile-extra-info h4{
      color:#111 !important;
      font-size:12px !important;
      font-weight:700 !important;
      letter-spacing:0 !important;
      margin:0 0 6px 0 !important;
      line-height:1.45 !important;
    }
    .profile-extra-info-list,
    .profile-extra-require{
      display:flex !important;
      flex-direction:column !important;
      gap:4px !important;
    }
    .profile-extra-info-item{
      display:flex !important;
      align-items:flex-start !important;
      gap:0 !important;
      font-size:12px !important;
      color:#111 !important;
      font-weight:400 !important;
      line-height:1.45 !important;
      page-break-inside:avoid !important;
    }
    .profile-extra-dot{display:none !important}
    .profile-extra-text{
      display:block !important;
      color:#111 !important;
      font-weight:400 !important;
      line-height:1.45 !important;
    }
    .profile-extra-note{
      border:none !important;
      background:transparent !important;
      box-shadow:none !important;
      border-radius:0 !important;
      padding:0 !important;
      margin:2px 0 0 0 !important;
      color:#111 !important;
      font-size:12px !important;
      font-style:normal !important;
      line-height:1.45 !important;
    }
    .profile-contact-row{
      display:flex !important;
      align-items:flex-start !important;
      gap:24px !important;
      margin:2px 0 !important;
      font-size:13px !important;
      line-height:1.45 !important;
      page-break-inside:avoid !important;
    }
    .profile-contact-item{
      display:flex !important;
      align-items:flex-start !important;
      min-width:0 !important;
    }
    .profile-contact-item strong{
      flex:0 0 auto !important;
      font-weight:700 !important;
      color:#111 !important;
    }
    .profile-contact-item span{
      font-weight:400 !important;
      color:#111 !important;
    }
    .profile-process-table{
      margin-top:16px !important;
      border:1px solid #dfe3ea !important;
      border-radius:6px !important;
      overflow:hidden !important;
      background:#fff !important;
      page-break-inside:avoid !important;
    }
    .profile-process-title{
      margin:0 !important;
      padding:10px 12px !important;
      background:#0457C2 !important;
      color:#fff !important;
      font-size:12px !important;
      font-weight:700 !important;
      line-height:1.45 !important;
      letter-spacing:0 !important;
    }
    .profile-process-grid{
      width:100% !important;
      margin:0 !important;
      border-collapse:collapse !important;
      font-size:11.5px !important;
      line-height:1.45 !important;
    }
    .profile-process-grid th{
      padding:7px 8px !important;
      background:#e5e7eb !important;
      color:#111 !important;
      font-weight:700 !important;
      line-height:1.45 !important;
    }
    .profile-process-grid td{
      padding:7px 8px !important;
      color:#111 !important;
      font-weight:400 !important;
      line-height:1.45 !important;
    }
    .profile-process-empty{
      color:#9ca3af !important;
      font-size:11px !important;
      font-weight:400 !important;
      font-style:italic !important;
      text-align:center !important;
      padding:8px !important;
    }
    .profile-download-footer{
      margin-top:16px !important;
      text-align:center !important;
      font-size:11px !important;
      line-height:1.45 !important;
      color:#333 !important;
      font-weight:400 !important;
      page-break-inside:avoid !important;
    }
    .profile-download-footer p{
      font-weight:400 !important;
      margin:0 !important;
    }
    .profile-download-footer a{
      color:#0457C2 !important;
      font-weight:600 !important;
      text-decoration:none !important;
    }

    .profile-heading{
      width:100%; text-align:center;
      font-family:${profileFontFamily} !important;
      font-weight:700; color:#0457C2; font-size:16px; text-transform:uppercase;
      padding:0 0 6px 0; border-bottom:1px solid #e5e7eb;
      letter-spacing:0;
      line-height:1.45 !important;
    }
  `
    : "";

  return `<!doctype html>
<html lang="vi">
<head>
  <meta charset="utf-8"/>
  <title>PDF</title>
  <style>
    :root{
      --page-w:${PAGE_W}px;
      --page-h:${PAGE_H}px;
    }
    *{box-sizing:border-box;margin:0;padding:0}
    ${profileFontFaceCSS}
    html,body{background:#fff;color:#111;font-family:${isProfileDocument ? profileFontFamily : "Inter,system-ui,-apple-system,Segoe UI,Roboto,sans-serif"}}
    a{color:#0457C2;text-decoration:none}
    @page{ size:${PAGE_W}px ${PAGE_H}px; margin: ${isProfileDocument ? "0.8cm 1.15cm 0.8cm 1.15cm" : "2.5cm 1.5cm"}; }
    body{ -webkit-print-color-adjust: exact; print-color-adjust: exact; }

    .pdf-root{
      width: 100%;
      margin:0 auto;
      line-height:${isProfileDocument ? "1.45" : "1.45"};
      font-size:${isProfileDocument ? "13px" : "13px"};
      display: block !important;
    }

    table{width:100% !important;border-collapse:collapse;font-size:${isProfileDocument ? "12px" : "12px"};margin-bottom:${isProfileDocument ? "8px" : "16px"};border:none !important}
    thead tr{background:#e5e7eb;height:auto}
    th,td{padding:${isProfileDocument ? "5px 6px" : "10px 8px"} !important;text-align:left;border:none !important}
    tbody tr{background:transparent !important; border: none !important}
    tbody tr:hover{background:transparent !important; border: none !important}
    th,td{border: none !important}
    ${profileCompactCSS}
    .generic-download-footer{
      margin-top:24px;
      text-align:center;
      font-size:10.5px;
      line-height:1.35;
      color:#333;
      page-break-inside:avoid;
    }

    ${watermarkMode === "absolute" ? watermarkAbsoluteCSS : watermarkFixedCSS}
  </style>
</head>
<body>
  <div class="pdf-root" id="contentToPrint">
    ${innerHtml}
    ${footerHTML}
  </div>
  ${overlayHtml}
</body>
</html>`;
}
